module.exports = __webpack_public_path__ + "media/images/finest-card-a4fe7a73b62c359febfaaaf6de1ff539.jpeg";